<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Відповідальний Співробітник'"
    :placeholder="placeholder || 'Введіть iм’я співробітника'"
    :items.sync="items"
    :total-items="totalItems"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    component-name="Employee"
    data-test="employee-select"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as employeesApi from "@/backend/employeesApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Виконавець",
    },
    value: {
      type: Object,
    },
    placeholder: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
  },
  data: () => ({
    totalItems: 0,
    items: [],
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await employeesApi.selectEmployee(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
